(function () {
  if (window.lopFormsCouponCopied) return;
  window.lopFormsCouponCopied = true;

  var HIDE_MS = 1800;
  var hideTimer = 0;
  var note = null;

  function findCopyButton(event) {
    var path = event.composedPath ? event.composedPath() : [];
    var i;
    var node;

    for (i = 0; i < path.length; i += 1) {
      node = path[i];
      if (node instanceof Element && node.matches('button[class*="copyToClipboardButton"]')) {
        return node;
      }
    }

    return null;
  }

  function ensureNote(button) {
    var root = button.getRootNode();
    var style;

    if (!root.querySelector('#lop-coupon-copied-style')) {
      style = document.createElement('style');
      style.id = 'lop-coupon-copied-style';
      root.appendChild(style);
    }

    root.querySelector('#lop-coupon-copied-style').textContent = [
        '.lop-coupon-copied-inline {',
        '  display: none;',
        '  box-sizing: border-box;',
        '  width: fit-content;',
        '  height: auto;',
        '  margin: 4px auto 8px;',
        '  padding: 5px 10px 9px;',
        '  border: 0;',
        '  border-radius: 4px;',
        '  background: #1878b9;',
        '  color: #ffffff;',
        '  font-family: inherit;',
        '  font-size: 12px;',
        '  font-weight: 600;',
        '  font-style: normal;',
        '  line-height: 1;',
        '  letter-spacing: 0;',
        '  text-transform: none;',
        '  align-items: center;',
        '  justify-content: center;',
        '  gap: 4px;',
        '}',
        '.lop-coupon-copied-inline.is-on { display: flex; }',
        '.lop-coupon-copied-inline__label {',
        '  display: block;',
        '  margin: 0;',
        '  padding: 0;',
        '  font-size: 12px;',
        '  font-weight: 600;',
        '  line-height: 1;',
        '}',
        '.lop-coupon-copied-inline svg {',
        '  /* !important: el SVG del cupón hereda el tamaño del ícono de copiar (~16px) */',
        '  display: block;',
        '  width: 8px !important;',
        '  height: 6px !important;',
        '  max-width: 8px !important;',
        '  max-height: 6px !important;',
        '  overflow: hidden;',
        '  flex: 0 0 auto;',
        '  transform: translateY(2px);',
        '}'
      ].join('');

    note = root.querySelector('.lop-coupon-copied-inline');
    if (!note) {
      note = document.createElement('div');
      note.className = 'lop-coupon-copied-inline';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      button.insertAdjacentElement('afterend', note);
    }

    if (!note.querySelector('.lop-coupon-copied-inline__label')) {
      note.textContent = '';
      note.appendChild(buildLabel());
      note.appendChild(buildCheck());
    }

    return note;
  }

  function buildLabel() {
    var label = document.createElement('span');
    label.className = 'lop-coupon-copied-inline__label';
    label.textContent = 'Copiado';
    return label;
  }

  function buildCheck() {
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    icon.setAttribute('viewBox', '1.4 2.4 9.2 7.2');
    icon.setAttribute('width', '8');
    icon.setAttribute('height', '6');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    icon.style.width = '8px';
    icon.style.height = '6px';
    path.setAttribute('d', 'M2.2 6.2 L4.8 8.8 L9.8 3.2');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.8');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    icon.appendChild(path);
    return icon;
  }

  function show(button) {
    var message = ensureNote(button);

    window.clearTimeout(hideTimer);
    message.classList.add('is-on');
    hideTimer = window.setTimeout(function () {
      message.classList.remove('is-on');
    }, HIDE_MS);
  }

  document.addEventListener('click', function (event) {
    var button = findCopyButton(event);
    if (!button) return;
    show(button);
  });

  var couponBlue = '#1878b9';

  function paintPopupCoupon(root) {
    var style = root.querySelector('#lop-popup-coupon-color');

    if (!style) {
      style = document.createElement('style');
      style.id = 'lop-popup-coupon-color';
      root.appendChild(style);
    }

    style.textContent = [
      '/* !important: Shopify Forms pinta el cupón del popup en rosa con su propia hoja dentro del shadow root */',
      ':host { --forms-discount-code-color: ' + couponBlue + ' !important; }',
      'button[class*="copyToClipboardButton"] span { color: ' + couponBlue + ' !important; }',
      'button[class*="copyToClipboardButton"] svg path { fill: ' + couponBlue + ' !important; }'
    ].join('');
  }

  function paintPopups() {
    var embeds = document.querySelectorAll('shopify-forms-embed');
    var i;

    for (i = 0; i < embeds.length; i += 1) {
      if (!embeds[i].shadowRoot) continue;
      if (embeds[i].id.indexOf('629227') === -1) continue;
      paintPopupCoupon(embeds[i].shadowRoot);
    }
  }

  paintPopups();
  window.setInterval(paintPopups, 1000);
})();
